import {CellContentInterface} from "./CellContentInterface";
import {is_same_object} from "../../utils/functions";
import {TextStyle} from "./TextStyle";
import {CHANGE_TEXT_STYLE_TYPE, TOGGLE_TEXT_STYLE_TYPE} from "./TextStyleType";
import {JcEditorState} from "./JcEditorState";


export class PerceptionContent implements CellContentInterface {
    private readonly editor_state: JcEditorState;

    constructor(editor_state: JcEditorState) {
        this.editor_state = editor_state;
    }

    get IsEmpty() {
        return this.editor_state.isEmpty();
    }

    get EditorState() {
        return this.editor_state;
    }

    withEditorState(editor_state: JcEditorState) {
        return new PerceptionContent(editor_state);
    }

    equals(other: this): boolean {
        return is_same_object(this.toJSON(), other.toJSON());
    }

    getTextStyle(): TextStyle {
        return this.editor_state.getTextStyle();
    }

    changeTextStyle(style_type: CHANGE_TEXT_STYLE_TYPE, value: string): PerceptionContent {
        return new PerceptionContent(this.editor_state.changeTextStyle(style_type, value));
    }

    toggleTextStyle(style_type: TOGGLE_TEXT_STYLE_TYPE): PerceptionContent {
        return new PerceptionContent(this.editor_state.toggleTextStyle(style_type));
    }

    toJSON(): object {
        return this.editor_state.toJSON();
    }

    toText(): string {
        return this.editor_state.toText();
    }

    static fromJSON(object: any): PerceptionContent {
        return new PerceptionContent(
            JcEditorState.createFromRaw(object)
        );
    }

    static createNew(): PerceptionContent {
        return new PerceptionContent(
            JcEditorState.createEmpty()
        );
    }

}
